import axios from 'axios'
import getAdmins from '../modules/getAdmins'

/**
 * Gets all the admins in the authenticated organization.
 */
export default function getOrganizationAdmins ({ commit, state }) {
  axios.get(`${process.env.VUE_APP_API_URL}api/admins`, {
    headers: {
      'x-access-token': localStorage.getItem('user-token')
    }
  })
    .then(function (response) {
      commit('updateAdmins', getAdmins(response.data.data))
    })
    .catch(function (error) {
      console.log(error)
    })
}
